export const JOB_PHASE_GARAGE_COST = 80;
